export enum QuotationGroups {
  AP = '000010',
  AUTOMOVILES = '000001',
  EFECTOS_PERSONALES = '000025',
  HOGAR = '000005',
  INCENDIO = '000045',
  INTEGRAL_COMERCIO = '000035',
  INTEGRAL_CONSORCIO = '000020',
  RESPONSABILIDAD_CIVIL = '000030',
  ROBO = '000015',
  VIDA_OBLIGATORIA = '000012',
}
